// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionPosts_wrapper__7k23F","post":"SectionPosts_post__HS0CE"};